import React, { FC } from 'react'
import { TFAQDataWithProps } from '@shared/types'
import { TFaq } from '../types'
import { FaqMobile } from './FaqMobile'
import { FaqDesktop } from './FaqDesktop'

export const Faq: FC<TFAQDataWithProps> = ({ onChangeCategory, faq }) => {
  const faqData: { sections: TFaq['sections'] } = {
    sections: faq.sections.map(({ category, content }, id) => ({
      title: category,
      questions: content.map(({ title, data }) => ({
        title,
        text: typeof data === 'string' ? data : data.join('{br}'),
      })),
      id: id.toString(),
    })),
  }

  return (
    <>
      <FaqDesktop {...faqData} onChangeCategory={onChangeCategory} />
      <FaqMobile {...faqData} />
    </>
  )
}
